import styled from 'styled-components';

export const UserStyled = styled.div`
  display: flex;
  align-items: center;
`;

//TODO: check if this can be removed
export const UserNameStyled = styled.span`
  padding-left: 5px;
  overflow-y: auto;
  max-height: 15em;
  overflow-wrap: break-word;
  word-break: break-word;
`;
